import { ExitToAppOutlined } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  LinearProgress,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { AuthAPIGateway } from "../../../../../api/httpClient";
import { AUTH_BASE_URL } from "../../../../../api/urls";
import { setError } from "../../../../../store/features/base/errorBaseSlice";
import { ButtonItem } from "../FooterActions";

const DialogConfirmation = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleExit = async () => {
    const currentEmail = window.localStorage.getItem("email") || "";

    setLoading(true);
    try {
      await AuthAPIGateway.logout();
      window.location.replace(
        `${AUTH_BASE_URL}?step=${currentEmail ? "1" : "0"}${
          currentEmail ? `&email=${currentEmail}` : ""
        }&redirect=${window.location.origin}`
      );
    } catch (error) {
      setLoading(false);
      dispatch(setError({ title: "Erro ao sair da conta", error }));
    }
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { maxWidth: 300 } }}
    >
      {loading && <LinearProgress />}
      <DialogTitle fontSize={"1.3rem"} fontWeight={"600"}>
        Tem certeza que deseja sair da conta?
      </DialogTitle>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          disableElevation
          disabled={loading}
          onClick={handleExit}
        >
          {loading ? "Saindo" : "Sair"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

function ExitButton(props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ButtonItem
        onClick={() => setOpen(true)}
        divider={false}
        Icon={ExitToAppOutlined}
      >
        Sair
      </ButtonItem>
      <DialogConfirmation open={open} onClose={() => setOpen(false)} />
    </>
  );
}

export default ExitButton;
